import { render, staticRenderFns } from "./freightClassification.vue?vue&type=template&id=27d0aba3&scoped=true"
import script from "./freightClassification.vue?vue&type=script&lang=js"
export * from "./freightClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0aba3",
  null
  
)

export default component.exports